import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import { EsTransactions } from "ui/organizms/QueryBuilder";

const EsTransactionsScreen = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Query Builder | Es-Transactions'
    >
        <EsTransactions />
    </Screen>
);

export default memo(EsTransactionsScreen);
